var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"unsubscribe-overlay"},[_c('div',{staticClass:"overlay-body"},[_c('label',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.subscribeText))]),_c('button',{staticClass:"btn btn-warning",on:{"click":_vm.sendSubscribeNowAnalytics}},[_vm._v("Subscribe Now")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }